import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-loading-dots',
  templateUrl: './loading-dots.component.html',
  styleUrls: ['./loading-dots.component.scss'],
  standalone: false,
})
export class LoadingDotsComponent {
  @Input() size = '3px';
}
